import React from "react";
import Button from "@mui/joy/Button";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Divider from "@mui/joy/Divider";
import Sheet from "@mui/joy/Sheet";
import Stack from '@mui/joy/Stack';
import Input from "@mui/joy/Input";
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import VideogameAssetIcon from '@mui/icons-material/VideogameAsset';
import Checkbox from '@mui/joy/Checkbox';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import {CommissionRule} from "../../models/commissionRule";
import {Game} from "../../models/games";

type DefaultProps = {
    rule: CommissionRule,
    open: boolean,
    allGames: Game[],
    setOpen: (e: boolean) => void,
    onConfirm: (rule: CommissionRule) => Promise<boolean>
}

const EditorDialog = (props: DefaultProps) => {
    const {rule, open, allGames, setOpen, onConfirm} = props;

    const [id] = React.useState(rule.id);
    const [gameId, setGameId] = React.useState(rule.gameId || 0);
    const [minAmount, setMinAmount] = React.useState(rule.minAmountExclusive);
    const [maxAmount, setMaxAmount] = React.useState(BigInt(rule.maxAmountInclusive || 0));
    const [fixedRate, setFixedRate] = React.useState(rule.fixedRate);
    const [percentRate, setPercentRate] = React.useState(rule.percentRate);
    const [disabled, setDisabled] = React.useState(rule.disabled);

    return (
        <Modal open={open} onClose={() => setOpen(false)}>
            <ModalDialog>
                <ModalClose/>
                <Typography id="filter-modal" level="h2">
                    {id <= 0 ? 'Новое правило' : 'Редактировать правило'}
                </Typography>
                <Divider sx={{my: 2}}/>
                <Sheet sx={{display: 'flex', flexDirection: 'column', gap: 2, overflowY: 'auto', overflowX: 'hidden'}}>
                    <FormControl>
                        <FormLabel>Игра</FormLabel>
                        <Select size="sm"
                                startDecorator={<VideogameAssetIcon/>}
                                placeholder="Игра"
                                value={gameId}
                                onChange={(_, value) => setGameId(value ?? 0)}>
                            <Option key={0} value={0}>(не установлено)</Option>
                            {allGames.map((p) => <Option key={p.id} value={p.id}>{p.name}</Option>)}
                        </Select>
                    </FormControl>
                    <div>
                        <FormLabel>Стоимость скина от(искл.) и до(включительно), в копейках</FormLabel>
                        <Stack direction={"row"} spacing={1}>
                            <Input placeholder="от (не включено)"
                                   value={minAmount.toString()}
                                   onChange={(event) => setMinAmount(BigInt(event.target.value))}/>
                            <Typography>-</Typography>
                            <Input placeholder="до (включено)"
                                   value={(maxAmount || 0) > 0 ? maxAmount?.toString() : ''}
                                   onChange={(event) => setMaxAmount(BigInt(event.target.value || 0))}/>
                        </Stack>
                    </div>
                    <FormControl>
                        <FormLabel>Комиссия в %</FormLabel>
                        <Input placeholder="% ставка комиссии"
                               value={(percentRate || -1) >= 0? percentRate?.toString() : ''}
                               onChange={(event) => setPercentRate(Number(event.target.value || -1))}/>
                    </FormControl>
                    <FormControl>
                        <FormLabel>Фиксированная сумма комиссии, в копейках</FormLabel>
                        <Input placeholder="сумма комиссии"
                               value={(fixedRate || -1) >= 0? fixedRate?.toString() : ''}
                               onChange={(event) => setFixedRate(BigInt(event.target.value || -1))}/>
                    </FormControl>
                    <Checkbox label="Активен"
                              checked={!disabled}
                              onChange={(event) => setDisabled(!event.target.checked)}/>
                    <Button
                        onClick={() => setOpen(false)}
                        color="neutral"
                    >
                        Отмена
                    </Button>
                    <Button
                        onClick={async ()  => {
                            if(await onConfirm({
                                id: rule.id,
                                gameId: gameId,
                                minAmountExclusive: minAmount,
                                maxAmountInclusive: maxAmount,
                                fixedRate: fixedRate,
                                percentRate: percentRate,
                                disabled: disabled,
                                updatedBy: rule.updatedBy,
                                created: rule.created,
                                updated: rule.updated
                            })) {
                                setOpen(false);
                            }
                        }}
                        color="primary"
                    >
                        Сохранить
                    </Button>
                </Sheet>
            </ModalDialog>
        </Modal>
    );
};

export default EditorDialog;